import Vue from 'vue';
// import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import VCalendar from 'v-calendar';

Vue.use(VCalendar, {
  firstDayOfWeek: 1,
  masks: {
    input: 'DD/MM/YYYY',
  },
});

// Register components in your 'main.js'
// Vue.component('v-date-picker', DatePicker);
